var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticStyle:{"text-decoration":"none","color":"inherit"},attrs:{"to":this.$props.path}},[_c('div',{staticClass:"button title"},[_vm._v(" Read More ")])])}
var staticRenderFns = []

export { render, staticRenderFns }